import { cardStyle } from "../pages/pageStyle";

export const aceEditorStyle = {
    border: '1px solid #EEE',
    marginBottom: 15,
    width: 'auto',
}

export const cardRightStyle = {
    ...cardStyle,
    float: 'left' as 'left',
}

export const buttonBarStyle = {
    marginBottom: 15,
}

export const buttonStyle = {
    marginRight: 10,
}

export const inputStyle = {
    maxWidth: 500,
    margin: '0px 0px 10px 0px',
}
